<template>
  <LineChart :chartData="chartdata" :options="options" />
</template>

<script>
import { mapGetters } from "vuex";
import { defineComponent } from "vue";
import { LineChart } from "vue-chart-3";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default defineComponent({
  name: "GraficoProjetoVida",
  components: { LineChart },
  computed: {
    ...mapGetters({
      participante: "participante",
    }),
  },
  data() {
    return {
      segmento: null,
      options: {
        responsive: true,
        plugins: {
          tooltip: false,
          legend: false,
        },
        maintainAspectRatio: false,
        scales: {
          y: {
            ticks: {
              callback: function (value) {
                return value / 1000 + ' k';
              },
              font: {
                size: 10,
              }
            }
          },
          x: {
            ticks: {
              font: {
                size: 10,
              }
            }
          }
        },
        elements: {
          point: {
            radius: 1,
          },
        },
      },
      chartdata: null
    };
  },
  created() {
      this.chartdata = (this.participante.projetoVida || '').grafico
    this.segmento = this.participante.segmento;
  },
  mounted() {
    if(this.chartdata){
      this.preencherSegmento();
    this.chartdata.datasets[3].fill = {
                target: 'origin',
                above: 'rgba(3, 49, 102, 0.7)',   // Area will be red above the origin
                below: 'rgba(49, 122, 187, 0.1)'    // And blue below the origin
              }
    }
   
  },
  methods: {
    preencherSegmento() {
      if (this.chartdata && this.chartdata.datasets) {
        for (var i = 0; i < this.chartdata.datasets.length; i++) {          
          this.chartdata.datasets[i].backgroundColor = this.segmento.seg_projeto_vida.grafico.datasets[i].backgroundColor;
          this.chartdata.datasets[i].borderColor = this.segmento.seg_projeto_vida.grafico.datasets[i].borderColor;
          this.chartdata.datasets[i].borderWidth = this.segmento.seg_projeto_vida.grafico.datasets[i].borderWidth;
        }
      }
    }
  }
});
</script>
